// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-module__menuContainer__ZJrJj {
    display: grid;
    grid-template-rows: min-content 1fr;
    margin-bottom: 4rem;
}

.menu-module__menuContainer__ZJrJj>div:first-child {
    text-align: center;
    padding: 1rem;
    margin: 3rem 0;
    font-size: 4rem;
    color: var(--color-green);
    border-bottom: 1px solid var(--color-border);
}

.menu-module__menuGrid__coJqV {
    max-width: 80%;
    justify-self: center;
    display: grid;
    grid-template: repeat(10, 1fr) / 1fr 1fr;
}

.menu-module__menuGrid__coJqV>div:nth-child(odd) {
    border-right: 1px solid var(--color-border);
}

.menu-module__menuGrid__coJqV>div {
    padding: 2rem 3rem;

    display: grid;
    grid-template: min-content 1fr / 1fr min-content;
}

.menu-module__menuGrid__coJqV>div {
    border-bottom: 1px solid var(--color-border);
}

.menu-module__menuGrid__coJqV>div:nth-last-child(-n+2) {
    border-bottom: none;
}

.menu-module__name__f0BMc {
    color: var(--color-green);
    grid-row: 1;
    grid-column: 1;
}

.menu-module__description__Lw_TC {
    font-size: 1.2rem;
    grid-row: 2;
    grid-column: 1;
}

.menu-module__price__Akni2 {
    grid-row: 1 / 2;
    grid-column: 2;
    color: var(--color-cyan);
}

.menu-module__price__Akni2::before {
    content: "\$";
}`, "",{"version":3,"sources":["webpack://./src/pages/menu/menu.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;;IAElB,aAAa;IACb,gDAAgD;AACpD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".menuContainer {\n    display: grid;\n    grid-template-rows: min-content 1fr;\n    margin-bottom: 4rem;\n}\n\n.menuContainer>div:first-child {\n    text-align: center;\n    padding: 1rem;\n    margin: 3rem 0;\n    font-size: 4rem;\n    color: var(--color-green);\n    border-bottom: 1px solid var(--color-border);\n}\n\n.menuGrid {\n    max-width: 80%;\n    justify-self: center;\n    display: grid;\n    grid-template: repeat(10, 1fr) / 1fr 1fr;\n}\n\n.menuGrid>div:nth-child(odd) {\n    border-right: 1px solid var(--color-border);\n}\n\n.menuGrid>div {\n    padding: 2rem 3rem;\n\n    display: grid;\n    grid-template: min-content 1fr / 1fr min-content;\n}\n\n.menuGrid>div {\n    border-bottom: 1px solid var(--color-border);\n}\n\n.menuGrid>div:nth-last-child(-n+2) {\n    border-bottom: none;\n}\n\n.name {\n    color: var(--color-green);\n    grid-row: 1;\n    grid-column: 1;\n}\n\n.description {\n    font-size: 1.2rem;\n    grid-row: 2;\n    grid-column: 1;\n}\n\n.price {\n    grid-row: 1 / 2;\n    grid-column: 2;\n    color: var(--color-cyan);\n}\n\n.price::before {\n    content: \"$\";\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuContainer": `menu-module__menuContainer__ZJrJj`,
	"menuGrid": `menu-module__menuGrid__coJqV`,
	"name": `menu-module__name__f0BMc`,
	"description": `menu-module__description__Lw_TC`,
	"price": `menu-module__price__Akni2`
};
export default ___CSS_LOADER_EXPORT___;
